// blog page slider js starts
(() => {
  const SELECTOR = ".blog-tags-slider";

  function initBlogTagSlider(container = document) {
    const sliders = container.querySelectorAll(SELECTOR);

    if (!sliders.length) return;

    sliders.forEach((slider) => {
      if (slider.classList.contains("swiper-initialized")) return;

      const swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 0,

        freeMode: {
          enabled: true,
          momentum: true,
        },

        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        breakpoints: {
          768: {
            freeMode: false,
          },
        },

        on: {
          init(swiperInstance) {
            scrollToActive(swiperInstance);
          },
        },
      });
    });
  }

  function scrollToActive(swiper) {
    const activeSlide = swiper.el.querySelector(".btn--active");

    if (!activeSlide) return;

    const slideEl = activeSlide.closest(".swiper-slide");
    if (!slideEl) return;

    const slides = Array.from(slideEl.parentNode.children);
    const index = slides.indexOf(slideEl);

    if (index >= 0) {
      swiper.slideTo(index, 400);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    initBlogTagSlider();
  });

  document.addEventListener("shopify:section:load", (e) => {
    initBlogTagSlider(e.target);
  });
})();
// ends
